/**
 * Single source of truth for the loaders' allowlists and the Hub's Sentry critical-vendor list.
 * A leaf module with no imports: the Sentry bootstrap imports it and is on the critical path.
 */
const BILLWERK_SDK_HOSTS = [
  'selfservice.exaring.billwerk.com',
  'selfservice.exaring-dev.billwerk.com',
  'selfservice.sandbox.billwerk.com',
] as const;

const PAYONE_SDK_HOST = 'secure.pay1.de';

// Frozen: the loaders use these as a script-origin allowlist.
export const BILLWERK_SDK_ORIGINS: readonly string[] = Object.freeze(BILLWERK_SDK_HOSTS.map((host) => `https://${host}`));

export const PAYONE_SDK_ORIGIN = `https://${PAYONE_SDK_HOST}`;

/** The form Sentry's `error_vendor` tag carries. */
export const PAYMENT_SDK_HOSTS: readonly string[] = Object.freeze([...BILLWERK_SDK_HOSTS, PAYONE_SDK_HOST]);
